import { render, staticRenderFns } from "./DialogTAccount.vue?vue&type=template&id=1f89321f&lang=pug&"
import script from "./DialogTAccount.vue?vue&type=script&lang=js&"
export * from "./DialogTAccount.vue?vue&type=script&lang=js&"
import style0 from "./DialogTAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogTAccount.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VDataTable,
  VDialog,
  VIcon,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
